import React from 'react';
import { Stack, Button, Paper, Chip } from '@mui/material';
import PropTypes from 'prop-types';
import CountDown from '../../common/countdown/index';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
const BidBottomWrap = ({ isRaiseBid, canDealerBid, isOcb, endTime = new Date(), handlePlaceBid, ocbV2 }) => {
    const buyNowFromOcb = isOcb && !ocbV2;

    const onPlaceBid = () => {
        handlePlaceBid(buyNowFromOcb ? { isLiveAndOcb: true } : null);
    };

    const getTitle = () => {
        let title = 'Place Bid';
        if (buyNowFromOcb) {
            title = 'Buy Now';
        } else if (isRaiseBid) title = 'Raise Bid';
        return title;
    };
    return (
        <Paper elevation={0} sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} className='px-4 py-4 z-10 border-t border-light-border rounded-none'>
            <Stack spacing={2} direction='row' alignItems={'center'} justifyContent='center'>
                <Button disabled={!canDealerBid} variant="contained" color='secondary' className='w-44 text-base py-2 font-bold' onClick={onPlaceBid}>{getTitle()}</Button>
                <Chip className='p-2' icon={<TimerOutlinedIcon className='text-active' />} label={<CountDown clsName='text-danger text-lg font-bold' isDate={true} date={endTime} />} />
            </Stack>
        </Paper>
    );
};

BidBottomWrap.propTypes = {
    canDealerBid: PropTypes.bool,
    isRaiseBid: PropTypes.bool,
    isOcb: PropTypes.bool,
    ocbV2: PropTypes.bool,
    endTime: PropTypes.any,
    handlePlaceBid: PropTypes.func
};

export default BidBottomWrap;
